module.exports = __webpack_public_path__ + "static/beige-9a34754927c8aa8671dc57131179f88e.jpg";